export type UserRole = 'member' | 'admin';
export type Phase = 1 | 2 | 3 | 4 | 5;

export interface FastTrackWeek {
  week: number;
  title: string;
  description: string;
  completed: boolean;
  homeworkSubmitted: boolean;
  homeworkItems: boolean[];
  callAttendanceType?: 'live' | 'replay' | null;
}

export type MigrationStatus = 'pending_first_login' | 'completed' | 'skipped';

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  phase: Phase;
  phase1Complete: boolean[];
  fastTrackWeeks: FastTrackWeek[];
  clarityCallBooked: boolean;
  criteriaSubmitted: boolean;
  criteriaCards: { label: string; value: string }[] | null;
  declaration: string;
  declarationSubmitted: boolean;
  migrationStatus: MigrationStatus | null;
}

export const FAST_TRACK_WEEKS: Omit<FastTrackWeek, 'completed' | 'homeworkSubmitted'>[] = [
  { week: 1, title: 'Discovery', description: 'Discover the program essentials.', homeworkItems: [false, false, false] },
  { week: 2, title: 'Decisions', description: 'Set criteria and evaluate options.', homeworkItems: [false, false] },
  { week: 3, title: 'Deal Flow', description: 'Source leads and analyze deals.', homeworkItems: [false, false] },
  { week: 4, title: 'Dollars & Debt', description: 'Finance structures and budgets.', homeworkItems: [false, false, false] },
  { week: 5, title: 'Disciplines', description: 'Operational routines and habits.', homeworkItems: [false, false, false] },
];

export const createDefaultUser = (email: string, name: string, role: UserRole = 'member'): User => ({
  id: crypto.randomUUID(),
  name,
  email,
  role,
  phase: 1,
  phase1Complete: [false, false, false],
  fastTrackWeeks: FAST_TRACK_WEEKS.map(w => ({ ...w, completed: false, homeworkSubmitted: false })),
  clarityCallBooked: false,
  criteriaSubmitted: false,
  criteriaCards: null,
  declaration: '',
  declarationSubmitted: false,
  migrationStatus: null,
});
